import { Pipe, PipeTransform } from '@angular/core';
import { ELanguage } from 'src/models/common.model';

@Pipe({
  name: 'transactionDescription',
  standalone: false
})
export class TransactionDescriptionPipe implements PipeTransform {
  /**
   * @param value transaction description from API
   * @param localization APP selected language
   * @returns description with localized decimal separator
   */
  public transform(value: string | null | undefined, localization: ELanguage): string {
    const description = value ?? '';
    if (localization !== ELanguage['cs-CZ']) {
      return description;
    }
    return description.replace(/(\d)\.(\d)/g, '$1,$2');
  }
}
